module.exports = __webpack_public_path__ + "files/6416b1a42b16d2a0d3c439b3b4a91662.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/smart_dark.png
// module id = 933
// module chunks = 76